import {Authentication} from "../Authentication";
import {handleHTTPError} from "../../components/ErrorFactory";
import {LoginFormModel} from "../../models/forms/LoginFormModel";
import {HTTPError} from "../../models/errors/HTTPError";

export async function loginForm(body: LoginFormModel) {
    // Input validation

    // Check that the form inputs are not null
    if (
        body.inputs.email.current == null ||
        body.inputs.password.current == null
    ) {
        body.setBanner(handleHTTPError(406, "One or more inputs is currently empty."))
        return;
    }
    // Check that the turnstile challenge has been attempted
    else if (body.inputs.cfTurnstileToken.current === "null") {
        body.setBanner(handleHTTPError(406, "Captcha challenge has not been attempted."))
        return;
    }
    // Check if the email is valid
    else if (!(body.inputs.email.current.value.includes('@') || body.inputs.email.current.value.includes('.'))) {
        body.setBanner(handleHTTPError(406, "Invalid email address."))
        return;
    }

    // Create auth object
    const auth = new Authentication(body.memory);

    // Authenticate the user
    try {
        await auth.Authenticate({
            email: body.inputs.email.current.value.trim(), // Removes whitespace
            password: body.inputs.password.current.value,
            cfTurnstileToken: body.inputs.cfTurnstileToken.current
        })

        // Redirect the user to their dashboard
        body.memory.memory[0].Router('/account/dashboard')
    }
    catch(e) {
        // If the error is a HTTP related exception
        if (e instanceof HTTPError) {
            body.setBanner(handleHTTPError(e.code, e.message))
        }
        else {
            body.setBanner(handleHTTPError(999, ""))
        }
    }
}